import { Component, OnInit, Input, AfterContentChecked, ElementRef, Renderer2 } from '@angular/core';
import { FormControl } from '@angular/forms';

import * as _ from 'lodash';

@Component({
  selector: 'app-validations-messages',
  templateUrl: './validations-messages.component.html',
  styleUrls: ['./validations-messages.component.scss']
})
export class ValidationsMessagesComponent implements OnInit, AfterContentChecked {
  @Input() inputField: FormControl;
  errorMessage: string;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {

  }

  /**
   * Check if the input field is invalid and touched.
   */
  isInvalidInput(): boolean {
    return this.inputField.invalid && this.inputField.touched;
  }

  ngAfterContentChecked() {
    if (this.isInvalidInput()) {
      // Add the class 'error' to the parent div node.
      this.renderer.addClass(this.elementRef.nativeElement.parentNode, 'error-field');

      // Get an array with the keys of all invalid errors.
      const errorKeys = _.keys(this.inputField.errors);

      // Define the error message only of the first error, to avoid multiple messages at same time.
      const errorKey = _.first(errorKeys);
      const errorValue = this.inputField.errors[errorKey];

      this.errorMessage = this.errorMessageDescription(errorKey, errorValue);
    } else {
      // Remove the class 'error' to the parent div node.
      this.renderer.removeClass(this.elementRef.nativeElement.parentNode, 'error-field');
    }
  }

  /**
   * Return a string with a description of an error key.
   * @param key Error key name of error message.
   * @param value Value that contains attributes like minlength or maxlength for specific validations.
   */
  private errorMessageDescription(key: string, value?: any): string {
    // Sets the error message due error type/key.
    const errorsMessages = {
      required: 'Por favor, preencha este campo.',
      email: 'Por favor, informe um endereço de email válido.',
      minlength: `Este campo aceita no mínimo ${ value.requiredLength } caracteres.`,
      maxlength: `Este campo aceita no máximo ${ value.requiredLength } caracteres.`,
      equalTo: 'Por favor, informe o mesmo valor novamente.',
      date: 'Por favor, informe uma data válida.',
      pattern: 'Sua senha deve conter apenas letras e números.',

      repeatCharacterRegexRule: `A senha não pode conter ${ value.repeatCount } caracteres repetidos em sequência.`,
      specialCharacterRule: 'A senha deve conter pelo menos um caracter especial.',
      digitCharacterRule: 'A senha deve conter pelo menos um número.',
      alphabeticalCharacterRule: 'A senha deve conter pelo menos um caracter alfabético.',
      lowercaseCharacterRule: 'A senha deve conter pelo menos uma letra minúscula.',
      uppercaseCharacterRule: 'A senha deve conter pelo menos uma letra maiúscula.',

      // checked: 'Por favor, marque esta caixa de seleção.',
      // url: 'Por favor, informe um endereço de site válido.',
      // integer: 'Por favor, informe um número inteiro válido.',
      // decimal: 'Por favor, informe um número decimal válido.',
      // number: 'Por favor, informe um número válido.',
      // regExp: 'O valor informado não é válido.',
      // creditCard: 'Por favor, informe um número de cartão de crédito válido.',
      // creditCardType: 'Por favor, informe um tipo de cartão de crédito válido (%{value}).',
      // contains: 'Este campo precisa conter o valor %{value}.',
      // containsExactly: 'Este campo precisa conter exatamente o valor %{value}.',
      // doesntContain: 'Este campo não pode conter o valor %{value}.',
      // doesntContainExactly: 'Este campo não pode conter exatamente o valor %{value}.',
      // is: 'O valor deste campo deve ser igual a %{value}.',
      // isExactly: 'O valor deste campo deve ser exatamente igual a %{value}.',
      // not: 'O valor deste campo não deve ser igual a %{value}.',
      // notExactly: 'O valor deste campo não deve ser exatamente igual a %{value}.',
      // exactLength: 'Este campo deve possuir %{value} caracteres.',
      // different: 'O valor deste campo não pode ser igual ao anterior.',
      // minCount: 'Você deve selecionar no mínimo %{value} itens.',
      // exactCount: 'Você deve selecionar %{value} itens.',
      // maxCount: 'Você deve selecionar no máximo %{value} itens.'
    };

    return errorsMessages[key];
  }
}
